import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";

















const utilityNamespace = 'ahCawCommonsUtility';


class AhCawCommonsUtility {
    constructor() {

    }

    getBasePath(spaParams) {
        return _.get(spaParams, 'siteParams.ahServiceEndpoint') ||
            _.get(spaParams, 'siteParams.serviceEndpoint') ||
            _.get(spaParams, 'siteParams.domain.hostname');

            }
    getEndPoints(endPoints, _basePath, fallbackPath) {
        const basePath = _basePath || fallbackPath;
        const apiEndPoints = {};
        Object.keys(endPoints).forEach((key) => {
            apiEndPoints[key] = basePath + endPoints[key];
        });
        return apiEndPoints;
    }

    getJSPath(spaParams, path) {
      return _.get(spaParams, path);
    }

    includeExternalResource(type, path, callback, triggerCallbackOnFailure = false) {
        console.log(`Loading :  ${path}`);
        let element;
        if (type === 'script') {
            element = document.createElement('script');
            element.setAttribute('src', path);
            element.setAttribute('async', 'true');
        } else if (type === 'style') {
            element = document.createElement('link');
            element.setAttribute('rel', 'stylesheet');
            element.setAttribute('type', 'text/css');
            element.setAttribute('href', path);
            element.setAttribute('async', 'true');
        } else {
            console.log(`Not loading. Unknown TYPE: ${type}`);
            return;
        }


        element.onreadystatechange = element.onload = function() {
            if (callback && !callback.done && (!element.readyState || /loaded|complete/.test(element.readyState))) {
                callback.done = true;
                callback();
            }
        };

        element.onerror = function() {
            if (triggerCallbackOnFailure === true &&
                callback && !callback.done) {
                console.log(`Unable to load: ${path}. Still triggering callback.`);
                callback.done = true;
                callback();
            } else {
                console.log(`Unable to load: ${path}. Callback not triggered.`);
            }
        };
        const head = document.getElementsByTagName('head')[0] || document.body;
        head.appendChild(element);
    }

    includeExternalResources(resType, resourceMap, callback, loadNextResurceOnFailure = true) {
        const resourceArray = _.values(resourceMap);

        if (resourceArray.length === 1) {
            this.includeExternalResource(resType, resourceArray[0], callback, false);
        } else {
            this.includeExternalResource(resType, resourceArray[0], () => {
                if (resourceArray.length > 1) {
                    this.includeExternalResources(resType, resourceArray.slice(1, resourceArray.length), callback, loadNextResurceOnFailure);
                }
            }, loadNextResurceOnFailure);
        }
    }

    handleError(errorRepo, options) {
        const response = { 'validErrorCode': false, 'errorType': '' };

        if (!options || !options.errorCode || !errorRepo) {
            return;
        }

        let errorCode;
        let errorParam;
        const presliced = options.errorCode;

                if (options.errorCode.split('_').length === 1) {
            errorCode = options.errorCode.split('_')[0]
        } else {
            errorCode = options.errorCode.split('_')[0] + '_x';
            errorParam = options.errorCode.split('_')[1];
        }

        if (_.get(errorRepo, `${errorCode}`)) {
            response.validErrorCode = true;
            response.errorType = _.get(errorRepo, `${errorCode}.type`);

            if (_.get(errorRepo, `${errorCode}.type`) === 'redirect') {
                window.location.href = options.basePath + _.get(errorRepo, `${errorCode}.href`);
            } 
            else if(_.get(errorRepo, `${errorCode}.type`) === 'cascade'){
                 spartaEventsUtility.pub("AH_CAW_COMMON_ERROR", options.errorCode); 
            }else {
                this._errorInline(
                    options,
                    _.get(errorRepo, `${errorCode}.title`).replace('{x}', errorParam),
                    _.get(errorRepo, `${errorCode}.message`).replace('{x}', errorParam)
                );
            }

            if (_.get(errorRepo, `${errorCode}.type`) === 'fatal') {
                if (options.$moduleContext && options.mainContainer) {
                    options.$moduleContext.find(options.mainContainer).addClass('hidden');
                }
            }
        }else{
            if(presliced && _.get(errorRepo, `${presliced}`) && _.get(errorRepo, `${presliced}.type`) !== 'cascade'){
                this._errorInline(
                    options,
                    _.get(errorRepo, `${presliced}.title`).replace('{x}', errorParam),
                    _.get(errorRepo, `${presliced}.message`).replace('{x}', errorParam)
                );
            }else if(presliced && _.get(errorRepo, `${presliced}`) && _.get(errorRepo, `${presliced}.type`) === 'cascade'){
                 spartaEventsUtility.pub("AH_CAW_COMMON_ERROR", options.errorCode); 
            }
        }

        return response;

    }

    _errorInline(config, title, content) {
        if (!content) {
            content = ' ';
        }
        let errorSize = 'large';
        if (config.size) {
            errorSize = config.size;
        }

        config.$moduleContext.find(config.errorTarget).empty();
        config.messageUtility.showErrorMessage(config.errorTarget, title, content, { insert: 'replace', size: errorSize });
        if (content === ' ') {
            config.$moduleContext.find('.spartaMessage-icon').removeAttr('style');
            config.$moduleContext.find('.spartaMessage-text').addClass('spartaMessage-no-text').removeClass('spartaMessage-text');
        }
    }


    _hideAll(elems, context) {
        for (const elem in elems) {
            context.find(elems[elem]).attr('aria-hidden','true').addClass('hide');
        }
    }

    _show(elem, context) {
        context.find(elem).attr('aria-hidden','false').removeClass('hide');
    }

    _showOnly(allElems, elem, context) {
        this._hideAll(allElems, context);
        context.find(elem).attr('aria-hidden','false').removeClass('hide');
    }

    trackCoreMetricesError(errorCode, errorMessage) {
        typeof bactm_captureCustomError === 'function' && bactm_captureCustomError(errorCode, errorMessage);
    }







    bindThisContext(methods, context, suffix ) {
      this.bindThisConext(methods,context,suffix);
    }






    bindThisConext(methods, context, suffix = 'Scoped') {
        const self = context;

        if (methods && $.isArray(methods) && methods.length > 0) {
            $(methods).each((index, method) => {
                if (self[method]) {
                    self[method + suffix] = self[method].bind(context);
                } else {
                    console.log(`Method: ${method} Not found in current context.`);
                }
            });
        }
    }
}






const ahCawCommonsUtility = new AhCawCommonsUtility();


export default ahCawCommonsUtility;
